import request from '@/utils/request';
export const getOrderTaskList = (params: any) =>
  request({
    url: 'OrderTask/orderList',
    method: 'get',
    params
  });

// 任务详情
export const getOrderTaskDetail = (params: any) =>
  request({
    url: 'OrderTask/orderDispose',
    method: 'get',
    params
  });

// 点击详情进入 任务详情
export const getTaskDetail = (params: any) =>
  request({
    url: 'OrderTask/order',
    method: 'get',
    params
  });

// 送修  orderSendRepair
export const taskSendRepair = (data: any) =>
  request({
    url: 'OrderTask/orderSendRepair',
    method: 'POST',
    data
  });

// 远程  orderRemote
export const taskRemote = (data: any) =>
  request({
    url: 'OrderTask/orderRemote',
    method: 'POST',
    data
  });

// 上门  orderVisit
export const taskVisit = (data: any) =>
  request({
    url: 'OrderTask/orderVisit',
    method: 'POST',
    data
  });

// 寄修  taskJiXiu
export const taskJiXiu = (data: any) =>
  request({
    url: 'OrderTask/orderSend',
    method: 'POST',
    data
  });

// 寄修  收货
export const taskSendReceive = (data: any) =>
  request({
    url: 'OrderTask/sendReceive',
    method: 'PUT',
    data
  });

// 转派  taskTransfer
export const taskTransfer = (data: any) =>
  request({
    url: 'OrderTask/orderTransfer',
    method: 'POST',
    data
  });

// 协同  orderCooperate
export const taskCooperate = (data: any) =>
  request({
    url: 'OrderTask/orderCooperate',
    method: 'POST',
    data
  });

// 任务完成   对于寄修方式  寄回即任务完成  orderFinish
export const taskFinish = (data: any) =>
  request({
    url: 'OrderTask/orderFinish',
    method: 'POST',
    data
  });

// 提审 orderCheck
export const orderTaskCheck = (data: any) =>
  request({
    url: 'OrderTask/orderCheck',
    method: 'put',
    data
  });

// 上报
export const orderTaskAppear = (data: any) =>
  request({
    url: 'OrderTask/orderAppear',
    method: 'put',
    data
  });

// 任务进度
export const getTaskProgressList = (params: any) =>
  request({
    url: 'OrderService/progressList',
    method: 'get',
    params
  });
  // 关闭任务
export const closeOrder = (data: any) =>
  request({
    url: 'OrderTask/closeOrder',
    method: 'put',
    data
  });
export const orderPause = (data: any) =>
  request({
    url: 'OrderTask/orderPause',
    method: 'POST',
    data
  });
// 新评价
export const getTaskDiyEvaluateList = (params: any) =>
  request({
    url: 'OrderTask/diyEvaluateList',
    method: 'get',
    params
  });
  export const diyEvaluate = (data: any) =>
  request({
    url: 'OrderTask/diyEvaluate',
    method: 'POST',
    data
  });
  export const ModifyDiyEvaluate = (data: any) =>
  request({
    url: 'OrderTask/diyEvaluate',
    method: 'PUT',
    data
  });
  export const batchAddDiyEvaluate = (data: any) =>
  request({
    url: 'OrderTask/batchAddDiyEvaluate',
    method: 'POST',
    data
  });